enum MainAttributeGroup {
  USER_INTERFACE = "UserInterface",
  SYSTEM = "System",
}
export default MainAttributeGroup;
